<div class="view-wrapper">
  <div class="header">
    <div class="left">
      <div class="search">
        <mat-form-field class="treo-mat-dense treo-mat-no-subscript">
          <mat-icon matPrefix [svgIcon]="'search'"></mat-icon>
          <input matInput [autocomplete]="'off'" [placeholder]="'Search properties'" />
        </mat-form-field>
      </div>
    </div>
    <div class="main-actions">
      <button class="today lt-md:hidden" [routerLink]="['../map']" mat-icon-button>
        <mat-icon [svgIcon]="'location_on'"></mat-icon>
      </button>
      <button class="today lt-md:hidden mr-4" [routerLink]="['../table']" mat-icon-button>
        <mat-icon [svgIcon]="'reorder'"></mat-icon>
      </button>
    </div>
  </div>
  <div class="products-list">
    <mgl-map
      [style]="'mapbox://styles/mapbox/light-v10'"
      [zoom]="[4]"
      [minZoom]="4"
      [projection]="'mercator'"
      [center]="[-94.578331, 39.099724]"
      (mapLoad)="map = $event.target"
    >
    </mgl-map>
  </div>
</div>
